import React, { useState, useEffect } from "react";
import {
  Accordion,
  Checkbox,
  TextInput,
  Box,
  Text,
  Stack,
} from "@mantine/core";
import { useServicePlanStyles } from "./style";

const ServicePlanAccordion = ({
  title,
  items,
  selectedItems = [],
  onChange,
  view = false,
  fullWidthAccordion = false,
  CareAndSafetyStep = false,
}) => {
  const { classes, cx } = useServicePlanStyles();
  const [localSelectedItems, setLocalSelectedItems] = useState(selectedItems);
  const [textFields, setTextFields] = useState({});

  useEffect(() => {
    setLocalSelectedItems(selectedItems);
    const initialTextFields = {};
    selectedItems.forEach((item) => {
      if (item?.text) {
        initialTextFields[item.name] = item.text;
      }
      item.subItems?.forEach((sub) => {
        if (sub.text) {
          const key = `${item.name}__${sub.name}`; // parent + subitem unique key
          initialTextFields[key] = sub.text;
        }
      });
    });
    setTextFields(initialTextFields);
  }, [selectedItems]);

  const isChecked = (name, itemObj) =>
    localSelectedItems.some((item) => item.name === name) ||
    localSelectedItems.some((item) =>
      item.subItems?.some(
        (sub) => item.name === itemObj?.name && sub.name === name,
      ),
    );

  const handleCheckboxChange = (item, checked) => {
    let newSelectedItems = [...localSelectedItems];

    if (checked) {
      if (!newSelectedItems.some((i) => i.name === item.name)) {
        newSelectedItems.push({ name: item.name });
      }
    } else {
      newSelectedItems = newSelectedItems.filter((i) => i.name !== item.name);
      const newTextFields = { ...textFields };
      delete newTextFields[item.name];
      item.subItems?.forEach((sub) => {
        const key = `${item.name}__${sub.name}`;
        delete newTextFields[key];
      });
      setTextFields(newTextFields);
    }

    setLocalSelectedItems(newSelectedItems);
    onChange(newSelectedItems);
  };

  // Handle sub-item checkbox
  const handleSubCheckboxChange = (parentItem, subItem, checked) => {
    const newSelectedItems = localSelectedItems.map((item) => {
      if (item.name !== parentItem.name) return item;

      const existingSubItems = item.subItems || [];

      if (checked) {
        // add subItem immutably
        if (existingSubItems.some((s) => s.name === subItem.name)) {
          return item;
        }

        return {
          ...item,
          subItems: [...existingSubItems, { name: subItem.name }],
        };
      }

      // remove subItem immutably
      const filteredSubItems = existingSubItems.filter(
        (s) => s.name !== subItem.name,
      );

      return {
        ...item,
        ...(filteredSubItems.length > 0 ? { subItems: filteredSubItems } : {}),
      };
    });

    // text cleanup
    if (!checked) {
      const key = `${parentItem.name}__${subItem.name}`;
      const newTextFields = { ...textFields };
      delete newTextFields[key];
      setTextFields(newTextFields);
    }

    setLocalSelectedItems(newSelectedItems);
    onChange(newSelectedItems);
  };

  const handleTextChange = (name, text, parentName = null) => {
    const key = parentName ? `${parentName}__${name}` : name;

    const newTextFields = { ...textFields, [key]: text };
    setTextFields(newTextFields);

    const newSelectedItems = localSelectedItems.map((item) => {
      if (item.name === name && !parentName) {
        return { ...item, ...(text ? { text } : {}) };
      }

      if (
        parentName &&
        item.name === parentName &&
        item.subItems?.some((sub) => sub.name === name)
      ) {
        const newSubItems = item.subItems.map((sub) =>
          sub.name === name ? { ...sub, ...(text ? { text } : {}) } : sub,
        );
        return { ...item, subItems: newSubItems };
      }
      return item;
    });

    setLocalSelectedItems(newSelectedItems);
    onChange(newSelectedItems);
  };

  return (
    <Accordion
      className={classes.fieldsAccordion}
      chevronPosition="right"
      defaultValue={title}
    >
      <Accordion.Item value={title}>
        <Accordion.Control>{title}</Accordion.Control>
        <Accordion.Panel>
          <Box className={fullWidthAccordion ? `${classes.fullWidthAccordion}` : classes.checkboxGroup}>
            {items.map((item) => {
              const checked = isChecked(item.name, item);

              return (
                <Box key={item.name} className={classes.checkboxItem}>
                  <Checkbox
                    checked={checked}
                    disabled={view}
                    onChange={(e) =>
                      handleCheckboxChange(item, e.target.checked)
                    }
                    label={item.name}
                    className={classes.checkboxAndLabelStyle}
                  />

                  {/* {checked &&
                    (!item.subItems || item.subItems.length === 0) && (
                      <TextInput
                        value={textFields[item.name] || ""}
                        onChange={(e) =>
                          handleTextChange(item.name, e.target.value)
                        }
                        placeholder="Add Text"
                        disabled={view}
                        className={classes.textInput}
                      />
                    )} */}

                  {item.subItems?.length > 0 && checked && (
                    <Box className={classes.checkboxItem}>
                      {item.subItems.map((sub) => {
                        const subChecked = isChecked(sub.name, item);
                        return (
                          <Box
                            key={sub.name}
                            className={cx(
                              classes.checkboxItem,
                              classes.subCheckboxItem,
                            )}
                          >
                            <Checkbox
                              checked={subChecked}
                              disabled={view}
                              onChange={(e) =>
                                handleSubCheckboxChange(
                                  item,
                                  sub,
                                  e.target.checked,
                                )
                              }
                              label={sub.name}
                              className={classes.checkboxAndLabelStyle}
                            />
                            {/* {CareAndSafetyStep && (
                              <TextInput
                                value={
                                  textFields[`${item.name}__${sub.name}`] || ""
                                }
                                onChange={(e) =>
                                  handleTextChange(
                                    sub.name,
                                    e.target.value,
                                    item.name,
                                  )
                                }
                                placeholder="Add Text"
                                disabled={view}
                                className={classes.textInput}
                              />
                            )} */}
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default ServicePlanAccordion;
